import React from "react";
import { Box, Typography } from "@mui/material";
import ENISImg from '../Assets/Images/ENIS-Logo.png'

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        backgroundColor: "#919295", // dark blue
        color: "white",
        textAlign: "right",
        padding:'5px 5px 5px 0px'
      }}
    >
      <Typography variant="body2">
        {/* © {new Date().getFullYear()} ENIS | Powered by ENIS Stock Management */}
        © 2025 GoldSun | Developed by <b style={{paddingLeft:'5px',paddingRight:'5px'}}><a href='https://eethalnaditsolutions.in/' target='blank'><img src={ENISImg} alt='ENIS' style={{width:'15px'}}/> ENIS</a></b>
      </Typography>
    </Box>
  );
};

export default Footer;
